var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 60,
    viewBox: "0 0 51 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2195 56.05H0.999512V1H31.0995L42.2195 12.12V56.05Z",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0995 1V12.12H42.2195",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7195 36.72H7.57947V51.01H14.7195V36.72Z",
    fill: "#5D68B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5095 29.41H18.2295V51.01H25.5095V29.41Z",
    fill: "#5D68B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1495 31.17H29.0095V51H36.1495V31.17Z",
    fill: "#5D68B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0495 58.15C44.7878 58.15 49.4395 53.4982 49.4395 47.76C49.4395 42.0218 44.7878 37.37 39.0495 37.37C33.3113 37.37 28.6595 42.0218 28.6595 47.76C28.6595 53.4982 33.3113 58.15 39.0495 58.15Z",
    fill: "white",
    stroke: "#5D68B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0496 41.97L40.9296 45.78L45.1296 46.39L42.0896 49.36L42.8096 53.54L39.0496 51.57L35.2896 53.54L36.0096 49.36L32.9696 46.39L37.1696 45.78L39.0496 41.97Z",
    fill: "#5D68B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.44,
    height: 59.14,
    fill: "white",
    transform: "translate(-0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.7681d481cb568e8178882721fe6faa5f.svg";
export { ForwardRef as ReactComponent };